import React from "react";
import { Tag } from "antd";
import { useSelector } from "react-redux";

import { makeSelectLanguage } from "../../../../containers/App/selectors";
import { DealNotificationStatuses } from "../../../../dto/Notification/DealNotificationDto";
import exhaustiveCheck from "../../../../utils/exhaustiveCheck";
import { DealNotificationUtils } from "../../../../viewModels/Notification/DealNotificationModel";

type Props = {
  status: DealNotificationStatuses;
};

const DealNotificationStatusTag = React.memo(({ status }: Props) => {
  const lang = useSelector(makeSelectLanguage());

  const getColor = () => {
    switch (status) {
      case "REQUESTED":
        return "default";
      case "RESPONDED":
        return "processing";
      case "CLOSED":
        return "success";
      default:
        return exhaustiveCheck(status);
    }
  };

  return (
    <Tag style={{ marginRight: 0 }} color={getColor()}>
      {DealNotificationUtils.getDealNotificationLabelByStatus(status, lang)}
    </Tag>
  );
});

export default DealNotificationStatusTag;
